export const ermBelt = (ctx: CanvasRenderingContext2D, leatherColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor
  ctx.beginPath()
  ctx.moveTo(384, 486) //
  ctx.quadraticCurveTo(365, 540, 408, 526) //
  ctx.quadraticCurveTo(424, 518, 433, 509) //
  ctx.quadraticCurveTo(465, 484, 508, 473) //
  ctx.quadraticCurveTo(552, 447, 571, 486) //
  ctx.quadraticCurveTo(580, 495, 574, 529) //
  ctx.quadraticCurveTo(564, 554, 564, 554) // 右下
  ctx.quadraticCurveTo(528, 587, 528, 587) //
  ctx.quadraticCurveTo(413, 550, 332, 587) // 左下
  ctx.quadraticCurveTo(289, 491, 289, 491) // 左上
  ctx.quadraticCurveTo(381, 478, 381, 478) //
  ctx.quadraticCurveTo(384, 486, 384, 486) //
  //   ctx.quadraticCurveTo() //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.fillStyle = '#ffffff'
  ctx.beginPath()
  ctx.arc(327, 516, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.arc(344, 560, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 右
  ctx.moveTo(380, 484) // 上
  ctx.quadraticCurveTo(380, 489, 377, 500)
  ctx.quadraticCurveTo(371, 521, 380, 528)
  ctx.quadraticCurveTo(389, 537, 420, 524)
  ctx.quadraticCurveTo(458, 489, 510, 477)
  ctx.quadraticCurveTo(558, 460, 570, 491)
  ctx.quadraticCurveTo(575, 500, 572, 526)
  // 左
  ctx.moveTo(377, 484) // 上
  ctx.quadraticCurveTo(377, 489, 374, 500)
  ctx.quadraticCurveTo(368, 524, 377, 531)
  ctx.quadraticCurveTo(386, 540, 417, 531)
  ctx.quadraticCurveTo(453, 499, 507, 482)
  ctx.quadraticCurveTo(552, 463, 566, 494)
  ctx.quadraticCurveTo(572, 503, 569, 529)
  // 手口の上
  ctx.moveTo(338, 581) // 上
  ctx.quadraticCurveTo(373, 564, 428, 562) //
  ctx.quadraticCurveTo(478, 562, 535, 579) //
  // ctx.quadraticCurveTo() //
  // ctx.moveTo() // 上
  // ctx.quadraticCurveTo() //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // stitch
}
